<template>
  <v-container class="pa-0">
    <v-row
      v-for="(item, index) in cart"
      :key="item.sku"
      class="swipe-container align-center border-b pb-2"
    >
      <!-- Botón rojo siempre al fondo -->
      <v-btn
        class="delete-btn"
        color="red"
        @click="removeItem(index)"
        rounded="0"
      >
        <v-icon color="white" size="26">mdi-delete</v-icon>
      </v-btn>

      <!-- Contenido deslizable -->
      <div
        class="swipe-content"
        :style="{ transform: `translateX(${item.translateX || 0}px)` }"
        @touchstart="startTouch($event, index)"
        @touchmove="moveTouch($event, index)"
        @touchend="endTouch($event, index)"
      >
        <v-col cols="2" class="d-flex justify-center">
          <v-img :src="item.foto" width="50" height="50" alt="Imagen"></v-img>
        </v-col>

        <v-col cols="5" class="text-caption">
          <div class="text-sm sm:text-base md:text-lg font-bold text-gray-700">{{ item.nombre }}</div>
          <div class="text-xs text-gray-500">SKU: {{ item.sku }}</div>
        </v-col>

        <v-col cols="5" class="d-flex justify-end align-center gap-2">
          <v-btn icon color="orange-darken-1" @click="decreaseQuantity(item)" :disabled="item.quantity <= 1">
            <v-icon size="20">mdi-minus</v-icon>
          </v-btn>

          <span class="px-2 text-caption font-bold">CJA {{ item.quantity }}</span>

          <v-btn icon color="blue-darken-4" class="text-white"
            @click="increaseQuantity(item)"
            :disabled="(item.id_promocion && item.quantity >= 1) ||
                       (item.promoUnico && item.quantity >= 1) ||
                       (item.sku && item.sku.startsWith('P')) ||
                       item.quantity >= item.yfr_disponible">
            <v-icon size="25">mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </div>
    </v-row>
    
  </v-container>
</template>

<script setup>
import { reactive } from 'vue'

const cart = reactive([
  { nombre: 'Refresco 600ml', sku: 'REF600', quantity: 2, foto: 'https://cdn.vuetifyjs.com/images/cards/cooking.png' },
  { nombre: 'Agua 500ml', sku: 'AG500', quantity: 1, foto: 'https://cdn.vuetifyjs.com/images/cards/cooking.png' }
])

let startX = 0
let currentIndex = null

const swipeThreshold = 40          // primer swipe mínimo para mostrar botón
const fullSwipeThreshold = 120     // swipe para eliminar
const buttonWidth = 80

function startTouch(e, index) {
  startX = e.touches[0].clientX
  currentIndex = index
}

function moveTouch(e, index) {
  if (currentIndex !== index) return
  const deltaX = e.touches[0].clientX - startX
  if (deltaX < 0) {
    cart[index].translateX = Math.max(deltaX, -buttonWidth)
  }
}

function endTouch(e, index) {
  const item = cart[index]

  if (item.translateX <= -fullSwipeThreshold) {
    // Deslizó hasta el final -> eliminar
    removeItem(index)
  } else if (item.translateX <= -swipeThreshold) {
    // Primer swipe -> mostrar parcialmente el botón
    item.translateX = -buttonWidth
  } else {
    // Volver a la posición inicial
    item.translateX = 0
  }
}

function removeItem(index) {
  cart.splice(index, 1)
}

function increaseQuantity(item) {
  item.quantity++
}

function decreaseQuantity(item) {
  if(item.quantity > 1) item.quantity--
}
</script>

<style scoped>
.swipe-container {
  position: relative;
  overflow: hidden;
  background: white;
  margin-bottom: 8px;
}

.delete-btn {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}

.swipe-content {
  display: flex;
  width: 100%;
  transition: transform 0.25s ease;
  background: white;
  z-index: 2;
}
</style>
